export const AWS_REGION_NAME = 'eu-central-1';
export const AWS_LAMBDA_NAME = 'certificatePortalAccessController';
export const AWS_LAMBDA_GET_PARAMETER_METHOD_NAME = 'getParameter';
export const AWS_LAMBDA_SET_PARAMETER_METHOD_NAME = 'setParameter';
export const AWS_SSM_PARAMETER_NAME = process.env.REACT_APP_ACCESS_PARAM_NAME;
export const PARAMETER_LOCK_VALUE = 'Lock';
export const PARAMETER_UNLOCK_VALUE = 'Unlock';
export const PORTAL_LOCK_LABEL = 'Durante el periodo de vigencia de las encuestas los resultados del curso actual están restringidos para la generación de informes';
export const PORTAL_UNLOCK_LABEL = 'Acceso al portal sin restricciones.';